import Img404 from "@simble/shared/assets/images/404.png";
import Button from "@simble/ui/button";
import { useNavigate } from "@tanstack/react-router";
import React from "react";
import PageLayout from "@/layouts/page-layout";
import Header from "./header";

const NotFoundPage = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate({ to: "/" });
  };

  return (
    <PageLayout className="flex h-full flex-col items-center justify-center" header={<Header />}>
      <div className="mt-[52px] mb-[60px] flex h-full flex-col items-center justify-center space-y-4 p-5 px-0 md:mt-[108px] md:mb-[120px] md:px-5">
        <img alt="" height={105} src={Img404} width={300} />
        <h5 className="headline5 text-center">Упс!</h5>
        <div className="body-regular text-center">
          На этом участке дороги — тупик. Предлагаем построить <br /> новый маршрут
        </div>
        <Button className="w-full font-normal" onClick={handleGoHome}>
          На главную
        </Button>
      </div>
    </PageLayout>
  );
};

export default React.memo(NotFoundPage);
